<template>
  <div>
    <div :class="(isBrandingFlag == 1) ? 'toggle_floater' : 'toggle_floater toggle_floater_withoutlogo'" v-if="isVisibleToggler == 1">

      <ul class="list-unstyled" style="padding-left: 0px;">
        <li class="">
          <b-link v-b-toggle="'collapse-buildable-submenu-toggler'" style="color: #6c757d;">
          <img src="@/assets/manager/Mentor_Mentee_Users_Icon_Not_Selected.png"  alt="Buildable Items" />
          <span class="menu-item-name white-txt">Switch To
          <i class="fa fa-angle-down report-dropdown float-right" style="font-size: 18px; margin-right: 17px !important;"></i>
          </span>
          </b-link>
        </li>
        <b-collapse v-bind:id="'collapse-buildable-submenu-toggler'" :visible="activeSubRoute()">
        <ul class="nav flex-column" style="margin-left: 15px !important;" v-if="isWhiteFlag == 1">
          <li :class="(selectedRole == 'Manager') ? 'active menu-active' : ''">
            <a class="p-0 cursor-pointer" @click="onchangeRoles('Manager')">
              <span class="menu-item-name white-txt" :class="(selectedRole == 'Manager') ? '' : 'text-muted'">Manager</span>
            </a>
          </li>
          <li :class="(selectedRole == 'Mentor') ? 'active menu-active' : ''">
            <a class="p-0 cursor-pointer" @click="onchangeRoles('Mentor')">
              <span class="menu-item-name white-txt" :class="(selectedRole == 'Mentor') ? '' : 'text-muted'">Mentor</span>
            </a>
          </li>
          <li :class="(selectedRole == 'Mentee') ? 'active menu-active' : ''">
            <a class="p-0 cursor-pointer" @click="onchangeRoles('Mentee')">
              <span class="menu-item-name white-txt" :class="(selectedRole == 'Mentee') ? '' : 'text-muted'">Mentee</span>
            </a>
          </li>
        </ul>
        <ul class="nav flex-column" style="margin-left: 15px !important;" v-else-if="isBrandingFlag == 1">
          <li :class="(selectedRole == 'Manager') ? 'active menu-active' : ''">
            <a class="p-0 cursor-pointer" @click="onchangeRoles('Manager')">
              <span class="menu-item-name" :class="(selectedRole == 'Manager') ? '' : 'text-muted'">Manager</span>
            </a>
          </li>
          <li :class="(selectedRole == 'Mentor') ? 'active menu-active' : ''">
            <a class="p-0 cursor-pointer" @click="onchangeRoles('Mentor')">
              <span class="menu-item-name" :class="(selectedRole == 'Mentor') ? '' : 'text-muted'">Mentor</span>
            </a>
          </li>
          <li :class="(selectedRole == 'Mentee') ? 'active menu-active' : ''">
            <a class="p-0 cursor-pointer" @click="onchangeRoles('Mentee')">
              <span class="menu-item-name" :class="(selectedRole == 'Mentee') ? '' : 'text-muted'">Mentee</span>
            </a>
          </li>
        </ul>
        <ul class="nav flex-column" style="margin-left: 15px !important;" v-else>
          <li :class="(selectedRole == 'Manager') ? 'active' : ''">
            <a class="p-0 cursor-pointer" @click="onchangeRoles('Manager')">
              <span class="menu-item-name" :class="(selectedRole == 'Manager') ? '' : 'text-muted'">Manager</span>
            </a>
          </li>
          <li :class="(selectedRole == 'Mentor') ? 'active' : ''">
            <a class="p-0 cursor-pointer" @click="onchangeRoles('Mentor')">
              <span class="menu-item-name" :class="(selectedRole == 'Mentor') ? '' : 'text-muted'">Mentor</span>
            </a>
          </li>
          <li :class="(selectedRole == 'Mentee') ? 'active' : ''">
            <a class="p-0 cursor-pointer" @click="onchangeRoles('Mentee')">
              <span class="menu-item-name" :class="(selectedRole == 'Mentee') ? '' : 'text-muted'">Mentee</span>
            </a>
          </li>
        </ul>
        </b-collapse>
      </ul>
    </div>

    <SwitchUserModal :isModalVisible="isModalVisible" @close="closeModal()">
      <div slot="header" class="sub-heading m-0"><h6 class="modal-title">Switch to {{ selectedRole }}</h6></div>
      <div slot="body" v-if="isModalVisible == true && userLoading == false">
        <div class="col-12 override-padding">
          <div class="col-12 override-padding form-group">
            <b-form-select name="selected_User" id="selected_User" v-model="selectedUser" :options="usersLists"
                style="margin-bottom: 0px !important; border-radius: 10px; margin-top: 2px;"
                class="col-12" v-validate="'required'" />
            <div v-if="verrors.firstByRule('selected_User', 'required')" class="margin-bottom-5 validate-warning-msg">User is required</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="col-12 p-0 text-center" v-if="userLoading == false">
        <button type="submit" class="btn btn-sm btn-blue submit_btn text-center" @click="onSubmit()">Switch User</button>
      </div>
    </SwitchUserModal>

  </div>
</template>

<script>
  import Vue from 'vue/dist/vue.esm';
  import axios from 'axios';
  import store from '../../store/store.js';
  import SwitchUserModal from '@/components/shared/switch-user-modal.vue';
  import router from '../../router/index.js';
  import VeeValidate from 'vee-validate';
  import { Validator } from "vee-validate";
  Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

  export default {
    props: ['isBrandingFlag', 'isWhiteFlag'],
    data() {
      return {
        apiUrl: '',
        selectedRole: '',
        isVisibleToggler: 0,
        roleLists: [
          { value: "Manager", text: "Manager" },
          { value: "Mentor", text: "Mentor" },
          { value: "Mentee", text: "Mentee" },
        ],
        isModalVisible: false,
        usersLists: [{ value: "", text: "Select User" },],
        selectedUser: '',
        userAccounts: {
            isUserLinkedMultipleLocations: false,
            locations: [],
            current: {},
        },
        locationsCount: 0,
        locations: [],
        userLoading: false,
      }
    },
    components: {
      SwitchUserModal,
    },
    computed: {
    },
    methods: {
      activeSubRoute() {
        if(this.selectedRole == 'Manager' || this.selectedRole == 'Mentor' || this.selectedRole == 'Mentee') {
          return true;
        }
        else {
          return false;
        }
      },
      onchangeRoles(role) {
        this.selectedRole = role;
        this.getUserLists();
        this.isModalVisible = true;
        this.verrors.clear();
        this.userLoading = true;
      },
      closeModal() {
        this.isModalVisible = false;
        this.selectedRole = this.$store.state.switch_flag;
      },
      getUserLists() {
        axios.get('/switch_user_get_userslist/' + this.$store.state.user_accountid, {
          params: {
            role: this.selectedRole,
          }
        })
        .then(response => {
          this.usersLists = [];
          var textlabel = 'Select ' + this.selectedRole;
          this.usersLists = [{ value: "", text: textlabel }];
          var userLists = response.data.usersListArray;
          for (var i = 0; i < userLists.length; i++) {
              this.usersLists.push({
                  'value': userLists[i].id,
                  'text': userLists[i].name,
              });
          }
          this.userLoading = false;
        })
        .catch(error => {

        });
      },
      navigate(path) {
        router.push(path);
      },
      onSubmit() {
        this.$validator.validateAll().then((result) => {
          if ((this.verrors.items.length === 0)) {
            this.switchUserLogin(this.selectedUser, this.selectedRole);
          }
        });
      },
      switchUserLogin: function(user_id, role) {
        axios.get('/admin_switch_user/' + user_id, {
        })
        .then(response => {
          let switch_admin_username = response.data.admin_username;
          let switch_admin_firstname = response.data.admin_firstname;
          let switch_admin_roles = response.data.admin_roles;
          let switch_admin_account_flag = response.data.admin_account_flag;
          this.$store.dispatch('switch_admin_user', { switch_admin_username, switch_admin_firstname, switch_admin_roles, switch_admin_account_flag });
          this.$store.dispatch('switch_user', role);
          this.locations = response.data.locations_results;
          this.locationsCount = this.locations.length;
          this.userAccounts.isUserLinkedMultipleLocations = false;
          this.userAccounts.locations = this.locations;
          Vue.prototype.$logoName = '';
          if (this.locationsCount > 1) {
              this.userAccounts.isUserLinkedMultipleLocations = true;
              this.$store.dispatch('set_user_locations', this.userAccounts);
              let routeData = this.$router.resolve({name: 'userselectlocation'});
              window.open(routeData.href, '_self');
          } else {
              this.$store.dispatch('set_user_accountid', this.userAccounts.locations[0].accId);
              this.$store.dispatch('set_user_locations', this.userAccounts);
              if(this.$store.state.switch_flag == 'Mentee') {
                let routeData = this.$router.resolve({name: 'menteedashboard'});
                window.open(routeData.href, '_self');
              }
              else if(this.$store.state.switch_flag == 'Mentor') {
                let routeData = this.$router.resolve({name: 'mentor_dashboard'});
                window.open(routeData.href, '_self');
              }
              else {
                let routeData = this.$router.resolve({name: 'manager_dashboard'});
                window.open(routeData.href, '_self');
              }
          }
        })
        .catch(error => {

        });
      },

    },
    created() {
      if(this.$store.state.switch_admin_username) {
        this.isVisibleToggler = 1;
        this.selectedRole = this.$store.state.switch_flag;
      }
    }
  }
</script>

<style scoped>
.toggle_floater {
  position: fixed; width: 100%; left: 0px;  bottom: 120px; text-align: left; 
}
.toggle_floater_withoutlogo {
  position: fixed; width: 100%; left: 0px;  bottom: 60px; text-align: left; 
}
.toggle_floater_text {
  text-align: left; 
  color: #002F42;
  font-size: 13px;
  margin-top: 5px;
}

.toggle_floater .active {
  background-color: #B1E6FA;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  margin-right: 30px;
}

.toggle_floater.active .menu-item-name {
  display: none;
}

.toggle_floater.active .sidebar-header h3 {
  display: none;
}

.toggle_floater.active .sidebar-header strong {
  display: block;
}

.toggle_floater ul li a {
  text-align: left;
  text-decoration: none;
  font-size: 13px;
  /* font-weight: bold; */
}

.toggle_floater ul li.active a {
  font-weight: bold;
}

.toggle_floater.active ul li a {
  padding: 0px 10px;
  text-align: center;
  font-size: 0.85em;
  text-decoration: none;
}

.toggle_floater.active ul li a i {
  margin-right: 0;
  display: block;
  font-size: 16px;
}

.toggle_floater.active ul ul a {
  padding: 10px !important;
}

.toggle_floater.active .dropdown-toggle::after {
  top: auto;
  bottom: 10px;
  right: 50%;
  -webkit-transform: translateX(50%);
  -ms-transform: translateX(50%);
  transform: translateX(50%);
}

.toggle_floater .sidebar-header {
  padding: 0px 10px 10px 10px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}

.toggle_floater ul.components {
  padding: 5px 0;
  border-bottom: 1px solid #47748b;
}

.toggle_floater ul li a {
  padding: 0px 10px 0px 10px;
  display: block;
  /* color: #212529; */
  margin-left: 5px;
}

.toggle_floater ul ul li a {
  padding: 2px;
}

.toggle_floater ul li a i {
  margin-right: 10px;
}

.toggle_floater ul li.active a i {
  color: #4DB1D8;
  font-weight: bold;
}

.toggle_floater ul li.active>a,
.toggle_floater a[aria-expanded="true"] {
  color: #212529;
}

.toggle_floater.active ul ul {
  display: none;
}

.toggle_floater ul li {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.toggle_floater ul li a.nav-active,
.toggle_floater ul li a.router-link-exact-active {
  /* border-left: 3px solid red; */
  /* border-left: 3px solid #00ACEE;
  margin-left: 2px; */
  border-left: none;
}

.toggle_floater ul li a i {
  width: 15px;
}

.toggle_floater ul li a img {
  width: 15px;
  margin-right: 10px;
}

.toggle_floater.active ul li a i {
  width: 35px;
}

</style>



// WEBPACK FOOTER //
// src/components/shared/toggle_users_floater.vue